
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rastreamento",
      function () {
        return require("private-next-pages/rastreamento.tsx");
      }
    ]);
  